import { defineStore } from "pinia";
import {
  getPlatformAuth,
  login,
  loginParam,
  loginOut,
  refreshToken,
  getPortsNum,
} from "/@/api/modules/user";
import {
  ILayout,
  IMenubarStatus,
  IMenubarList,
  ISetting,
  IMenubar,
  IStatus,
  IUserInfo,
  IPlatformAuth,
  IportInfo,
} from "/@/type/store/layout";
import router from "/@/router/index";
import { allowRouter } from "/@/router/index";
import { setLocal, getLocal, decode } from "/@/utils/tools";
import type { AxiosResponse } from "axios";
import UseMqtt from "/@/utils/UseMqtt";

const { addLink } = UseMqtt();
const setting = getLocal<ISetting>("setting");
const { ACCESS_TOKEN } = getLocal<IStatus>("token");

export const useLayoutStore = defineStore({
  id: "layout",
  state: (): ILayout => ({
    menubar: {
      status:
        document.body.offsetWidth < 768
          ? IMenubarStatus.PHN
          : IMenubarStatus.PCE,
      menuList: [],
      isPhone: document.body.offsetWidth < 768,
    },
    /**
     * {name,username,expireTime,usedPort,multiAccount}
     * {名字,账号,已启用端口,可分配端口}
     */
    userInfo: {
      id: 0,
      name: "", //
      username: "",
      expireTime: "",
      usedPort: 0,
      multiAccount: 0,
    },
    platformAuth: {
      list: [],
    },
    setting: {
      theme: setting.theme !== undefined ? setting.theme : 0,
      color: {
        primary:
          setting.color !== undefined ? setting.color.primary : "#409eff",
      },
      mode: setting.mode || "vertical",
    },
    status: {
      isLoading: false,
      ACCESS_TOKEN: ACCESS_TOKEN || "",
    },
    portInfo: {
      freePorts: 0,
      total: 0,
      usePorts: 0,
    },
  }),
  getters: {
    getMenubar(): IMenubar {
      console.log(this.menubar, "******getMenubar**");
      return this.menubar;
    },
    getUserInfo(): IUserInfo {
      return this.userInfo;
    },
    getSetting(): ISetting {
      return this.setting;
    },
    getStatus(): IStatus {
      return this.status;
    },
    getPlatformAuth(): IPlatformAuth {
      return this.platformAuth;
    },
    getportInfo(): IportInfo {
      return this.portInfo;
    },
  },
  actions: {
    changeCollapsed(): void {
      console.log(IMenubarStatus, "**IMenubarStatus***", this.menubar);
      this.menubar.status = this.menubar.isPhone
        ? this.menubar.status === IMenubarStatus.PHN
          ? IMenubarStatus.PHE
          : IMenubarStatus.PHN
        : this.menubar.status === IMenubarStatus.PCN
        ? IMenubarStatus.PCE
        : IMenubarStatus.PCN;
    },
    changeDeviceWidth(): void {
      this.menubar.isPhone = document.body.offsetWidth < 768;
      this.menubar.status = this.menubar.isPhone
        ? IMenubarStatus.PHN
        : IMenubarStatus.PCE;
    },
    async logout(): Promise<void> {
      try {
        await loginOut();
        this.reomveStorage(true);
      } catch (error) {}
    },
    // token失效 跳转到登录页面
    tokenInvalidation() {
      router.push({ path: "/Login" });
    },
    reomveStorage(isExit?: Boolean): void {
      this.status.ACCESS_TOKEN = "";

      localStorage.removeItem("token");
      localStorage.removeItem("platformAuth");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("portInfo");
      if (isExit) history.go(0);
    },
    setToken(token: string): void {
      this.status.ACCESS_TOKEN = token;
      setLocal("token", this.status, 1000 * 60 * 60 * 24 * 6);
    },
    setRoutes(data: Array<IMenubarList>): void {
      this.menubar.menuList = data;
    },
    concatAllowRoutes(): void {
      allowRouter.reverse().forEach((v) => this.menubar.menuList.unshift(v));
    },
    // 登录
    async login(param: loginParam): Promise<void> {
      console.log(param);
      const res = await login(param);
      this.userInfo = res.data.userInfo;
      this.portInfo = res.data.portInfo;
      this.setToken(res.data.token);
      localStorage.setItem("portInfo", JSON.stringify(this.portInfo));
      localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      // this.getPlatformAuthFun();
      // const { query } = router.currentRoute.value;
      router.push("/");
    },
    // 平台权限
    async getPlatformAuthFun(): Promise<AxiosResponse<IResponse>> {
      const res = await getPlatformAuth();
      this.platformAuth.list = res.data;
      localStorage.setItem("platformAuth", JSON.stringify(this.platformAuth));
      return res;
    },
    // 刷新token
    async refreshToken(): Promise<AxiosResponse<IResponse>> {
      const res = await refreshToken();
      this.setToken(res.data.token);
      return res;
    },
    // 更新用户端口信息
    async getPortsNum(): Promise<void> {
      const res = await getPortsNum();
      this.portInfo = res.data;
      localStorage.setItem("portInfo", JSON.stringify(res.data));
    },
  },
});
